import { Controller } from "@hotwired/stimulus"

// Demo-only: client-side tab switching for a mock. Tabs and panels are paired by
// their data-index; clicking a tab shows the matching panel and hides the rest.
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { active: { type: Number, default: 0 } }

  connect() {
    this.show(this.activeValue)
  }

  select(event) {
    this.show(Number(event.currentTarget.dataset.index))
  }

  show(index) {
    this.tabTargets.forEach((t) =>
      t.classList.toggle("tab-active", Number(t.dataset.index) === index),
    )
    this.panelTargets.forEach((p) =>
      p.classList.toggle("hidden", Number(p.dataset.index) !== index),
    )
  }
}
